import React from 'react';
import GeneralUtils from '../../utils/GeneralUtils';

export default function EnvironmentBanner() {
    const banner = GeneralUtils.getEnvironmentBanner();
    if (!banner) {
        return null;
    }

    return (
        <div
            className={`environment-banner environment-banner--${banner.type}`}
            role="status"
            aria-live="polite"
        >
            <span className="environment-banner__icon pi pi-exclamation-triangle" aria-hidden="true"/>
            <span className="environment-banner__label">{banner.label}</span>
            <span className="environment-banner__separator" aria-hidden="true">·</span>
            <span className="environment-banner__subtitle">{banner.subtitle}</span>
        </div>
    );
}
